import useApiMutation from 'shared/hooks/use-api-mutation';

const useResetPasswordConfirm = () => {
  return useApiMutation({
    method: 'PATCH',
    url: '/auth/reset-password',
    errorTitle: 'Erro ao redefinir senha',
    successTitle: 'Redefinir senha',
    successMessage: 'Senha alterada com sucesso',
    redirectUrl: '/login',
  });
};

export default useResetPasswordConfirm;
